import { useState, useEffect, useRef } from 'react';
import api from '../services/api';

const SPECS = {
  logo: {
    label: 'Logo',
    desc: 'Esquina superior izquierda del pass',
    width: 480, height: 150,
    ratio: '3.2:1',
    formato: 'PNG con fondo transparente',
    tip: 'Fondo transparente para que se vea sobre cualquier color',
    icon: '🏷️',
  },
  strip: {
    label: 'Banner del pass (Strip Image)',
    desc: 'Imagen central — ideal para campañas y branding',
    width: 1125, height: 432,
    ratio: '3:1',
    formato: 'PNG o JPG',
    tip: 'Evita texto importante en los bordes, pueden recortarse',
    icon: '🖼️',
  },
  google_hero: {
    label: 'Hero Image (Google Wallet)',
    desc: 'Imagen principal en Android',
    width: 1032, height: 336,
    ratio: '3:1',
    formato: 'PNG o JPG',
    tip: 'Se muestra debajo del logo en Google Wallet',
    icon: '🤖',
  },
};

function ImageUploader({ spec, value, onChange, apiUpload }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(value);

  useEffect(() => { setPreview(value); }, [value]);

  const handleFile = async (file) => {
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) { alert('La imagen no debe superar 2MB'); return; }

    setUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const base64 = e.target.result;
        setPreview(base64); // preview inmediato

        // Subir a Cloudinary via backend
        const res = await apiUpload(base64);
        if (res.success) {
          setPreview(res.url);
          onChange(res.url);
        }
        setUploading(false);
      };
      reader.readAsDataURL(file);
    } catch {
      alert('Error subiendo imagen');
      setUploading(false);
    }
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <span style={{ fontSize: 16 }}>{spec.icon}</span>
        <div>
          <div style={s.label}>{spec.label}</div>
          <div style={{ fontSize: 11, color: '#888' }}>{spec.desc}</div>
        </div>
      </div>

      {/* Specs box */}
      <div style={s.specsBox}>
        <div style={s.specItem}><strong>Tamaño:</strong> {spec.width} × {spec.height} px</div>
        <div style={s.specItem}><strong>Ratio:</strong> {spec.ratio}</div>
        <div style={s.specItem}><strong>Formato:</strong> {spec.formato}</div>
        <div style={{ ...s.specItem, gridColumn: '1/-1', color: '#f59e0b' }}>💡 {spec.tip}</div>
      </div>

      {/* Upload area */}
      <div style={{ ...s.uploadArea, opacity: uploading ? 0.6 : 1 }}
        onClick={() => !uploading && inputRef.current.click()}
        onDragOver={e => e.preventDefault()}
        onDrop={e => { e.preventDefault(); handleFile(e.dataTransfer.files[0]); }}>
        {uploading ? (
          <div style={{ textAlign: 'center', color: '#888' }}>
            <div style={{ fontSize: 20, marginBottom: 4 }}>⏳</div>
            <div style={{ fontSize: 12 }}>Subiendo a Cloudinary...</div>
          </div>
        ) : preview ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <img src={preview} alt={spec.label}
              style={{ height: 48, maxWidth: 120, objectFit: 'contain', borderRadius: 4, border: '1px solid #eee' }} />
            <div>
              <div style={{ fontSize: 12, color: '#333', fontWeight: 600 }}>Imagen cargada ✓</div>
              <div style={{ fontSize: 11, color: '#888' }}>Click o arrastra para cambiar</div>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: 'center', color: '#aaa' }}>
            <div style={{ fontSize: 28, marginBottom: 6 }}>📤</div>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#555' }}>Click o arrastra la imagen aquí</div>
            <div style={{ fontSize: 11, marginTop: 4 }}>{spec.width} × {spec.height} px · {spec.formato}</div>
          </div>
        )}
      </div>

      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/jpg"
        style={{ display: 'none' }}
        onChange={e => handleFile(e.target.files[0])} />

      {preview && (
        <button style={s.btnRemove} onClick={() => { setPreview(null); onChange(null); }}>
          Quitar imagen
        </button>
      )}
    </div>
  );
}

export default function Diseno() {
  const [config, setConfig] = useState({
    bg_color:        '#dc1414',
    fg_color:        '#ffffff',
    label_color:     '#ffdddd',
    logo_text:       '2CAP',
    program_name:    'Programa de Lealtad 2CAP',
    org_name:        'Operadora de Tiendas Garcam',
    points_label:    'PUNTOS',
    promo_text:      '',
    logo_url:        null,
    strip_image_url: null,
    google_hero_url: null,
    // Reverso del pass
    back_info:       'Presenta esta tarjeta en caja para acumular puntos en cada compra.',
    url_web:         'https://2cap.com.mx/',
    url_instagram:   'https://www.instagram.com/2capmx/',
    url_tiktok:      'https://www.tiktok.com/@2capmx_',
    url_facebook:    'https://www.facebook.com/2CAPMX/',
    url_privacidad:  'https://2cap.com.mx/pages/privacidad',
  });
  const [saved, setSaved]     = useState(false);
  const [saving, setSaving]   = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/pass-design').then(r => {
      if (r.data.success) setConfig(prev => ({ ...prev, ...r.data.data }));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const update = (k, v) => setConfig(prev => ({ ...prev, [k]: v }));

  const uploadImage = async (base64, type) => {
    const res = await api.post('/api/pass-design/upload', { image: base64, type });
    return res.data;
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.post('/api/pass-design', config);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { alert('Error guardando el diseño'); }
    finally { setSaving(false); }
  };

  if (loading) return <div style={{ padding: 40, color: '#888' }}>Cargando diseño...</div>;

  return (
    <div>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Diseño de Passes</h1>
          <p style={s.sub}>Personaliza la apariencia de las tarjetas de lealtad</p>
        </div>
        <button style={s.btnPrimary} onClick={save} disabled={saving}>
          {saving ? 'Aplicando...' : saved ? '✓ Guardado y aplicado' : 'Guardar y aplicar'}
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: 24 }}>

        {/* ─── Panel izquierdo ─── */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

          {/* Imágenes */}
          <div style={s.card}>
            <div style={s.cardHead}>Imágenes</div>
            <ImageUploader spec={SPECS.logo} value={config.logo_url}
              onChange={v => update('logo_url', v)}
              apiUpload={b64 => uploadImage(b64, 'logo')} />
            <ImageUploader spec={SPECS.strip} value={config.strip_image_url}
              onChange={v => update('strip_image_url', v)}
              apiUpload={b64 => uploadImage(b64, 'strip')} />
            <ImageUploader spec={SPECS.google_hero} value={config.google_hero_url}
              onChange={v => update('google_hero_url', v)}
              apiUpload={b64 => uploadImage(b64, 'google_hero')} />
          </div>

          {/* Texto */}
          <div style={s.card}>
            <div style={s.cardHead}>Textos</div>
            {[
              ['Texto del logo (si no hay imagen)', 'logo_text', 'Ej: 2CAP'],
              ['Nombre del programa', 'program_name', 'Ej: Programa de Lealtad 2CAP'],
              ['Nombre de la organización', 'org_name', 'Ej: Operadora de Tiendas Garcam'],
              ['Etiqueta de puntos', 'points_label', 'Ej: PUNTOS'],
            ].map(([label, key, placeholder]) => (
              <div key={key} style={s.field}>
                <label style={s.label}>{label}</label>
                <input style={s.input} value={config[key]} placeholder={placeholder}
                  onChange={e => update(key, e.target.value)} />
              </div>
            ))}
            <div style={s.field}>
              <label style={s.label}>Últimas promociones <span style={{ color: '#888', fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>— aparece en el pass</span></label>
              <textarea style={{ ...s.input, height: 80, resize: 'vertical' }}
                value={config.promo_text}
                placeholder="Ej: 🎉 20% de descuento en todas las compras este mes"
                onChange={e => update('promo_text', e.target.value)}
                maxLength={100} />
              <span style={{ fontSize: 11, color: '#bbb' }}>{(config.promo_text || '').length}/100</span>
            </div>
          </div>

          {/* Colores */}
          <div style={s.card}>
            <div style={s.cardHead}>Colores</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
              {[
                ['Color de fondo', 'bg_color'],
                ['Color de texto', 'fg_color'],
                ['Color de etiquetas', 'label_color'],
              ].map(([label, key]) => (
                <div key={key}>
                  <label style={s.label}>{label}</label>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <input type="color" value={config[key]}
                      onChange={e => update(key, e.target.value)}
                      style={{ width: 44, height: 40, border: '1.5px solid #e5e5e5', cursor: 'pointer', padding: 2 }} />
                    <input style={{ ...s.input, fontSize: 11, flex: 1 }}
                      value={config[key]} onChange={e => update(key, e.target.value)} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Reverso del pass */}
          <div style={s.card}>
            <div style={s.cardHead}>Reverso del pass <span style={{ color: '#aaa', fontSize: 10, fontWeight: 400 }}>— info adicional y links</span></div>
            <div style={s.field}>
              <label style={s.label}>Texto de información</label>
              <textarea style={{ ...s.input, height: 70, resize: 'vertical' }}
                value={config.back_info || ''}
                placeholder="Presenta esta tarjeta en caja para acumular puntos..."
                onChange={e => update('back_info', e.target.value)} />
            </div>
            {[
              ['🌐 Sitio web', 'url_web', 'https://2cap.com.mx/'],
              ['📸 Instagram', 'url_instagram', 'https://www.instagram.com/2capmx/'],
              ['🎵 TikTok', 'url_tiktok', 'https://www.tiktok.com/@2capmx_'],
              ['👤 Facebook', 'url_facebook', 'https://www.facebook.com/2CAPMX/'],
              ['🔒 Aviso de privacidad', 'url_privacidad', 'https://2cap.com.mx/pages/privacidad'],
            ].map(([label, key, placeholder]) => (
              <div key={key} style={s.field}>
                <label style={s.label}>{label}</label>
                <input style={s.input} value={config[key] || ''}
                  placeholder={placeholder}
                  onChange={e => update(key, e.target.value)} />
              </div>
            ))}
            <div style={s.infoBox}>
              Estos links aparecen en el reverso del pass. El usuario puede tocarlos para abrirlos directamente desde Wallet.
            </div>
          </div>
        </div>

        {/* ─── Preview ─── */}
        <div style={{ position: 'sticky', top: 20, alignSelf: 'start' }}>
          <div style={s.card}>
            <div style={s.cardHead}>Vista previa</div>
            <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
              <div style={{ width: 280, borderRadius: 16, overflow: 'hidden', boxShadow: '0 12px 40px rgba(0,0,0,0.2)', background: config.bg_color }}>

                {/* Header */}
                <div style={{ padding: '16px 16px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  {config.logo_url ? (
                    <img src={config.logo_url} alt="logo" style={{ height: 28, objectFit: 'contain', maxWidth: 100 }} />
                  ) : (
                    <div style={{ background: 'rgba(255,255,255,0.15)', padding: '4px 10px', borderRadius: 3 }}>
                      <span style={{ fontWeight: 800, fontSize: 13, color: config.fg_color, letterSpacing: 1 }}>{config.logo_text}</span>
                    </div>
                  )}
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 8, color: config.label_color, letterSpacing: 1.5 }}>{config.points_label}</div>
                    <div style={{ fontSize: 22, fontWeight: 800, color: config.fg_color, lineHeight: 1 }}>500</div>
                  </div>
                </div>

                {/* Strip image o color */}
                {config.strip_image_url ? (
                  <img src={config.strip_image_url} alt="banner"
                    style={{ width: '100%', height: 108, objectFit: 'cover', display: 'block', marginTop: 12 }} />
                ) : (
                  <div style={{ margin: '12px 0', height: 80, background: 'rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>Banner / Strip Image</span>
                  </div>
                )}

                {/* Campos */}
                <div style={{ padding: '12px 16px' }}>
                  <div style={{ display: 'flex', gap: 16, marginBottom: 10 }}>
                    <div>
                      <div style={{ fontSize: 8, color: config.label_color, letterSpacing: 1.5 }}>TITULAR</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: config.fg_color }}>Fernando Valdez</div>
                    </div>
                    <div>
                      <div style={{ fontSize: 8, color: config.label_color, letterSpacing: 1.5 }}>NIVEL</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: config.fg_color }}>Standard</div>
                    </div>
                  </div>

                  {/* Promo text */}
                  {config.promo_text && (
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: 6, padding: '6px 10px', marginBottom: 10 }}>
                      <div style={{ fontSize: 8, color: config.label_color, letterSpacing: 1.5, marginBottom: 2 }}>ÚLTIMAS PROMOCIONES</div>
                      <div style={{ fontSize: 10, color: config.fg_color, lineHeight: 1.4 }}>{config.promo_text}</div>
                    </div>
                  )}

                  {/* QR */}
                  <div style={{ background: '#fff', borderRadius: 6, padding: 8, display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: 60, height: 60, background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8, color: '#aaa' }}>QR</div>
                  </div>
                </div>
              </div>
            </div>
            <div style={s.infoBox}>Al guardar, todos los passes se actualizarán automáticamente.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const s = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 28 },
  title: { fontSize: 24, fontWeight: 700, margin: '0 0 4px', color: '#111', fontFamily: "'Barlow Condensed',sans-serif", textTransform: 'uppercase', letterSpacing: -0.5 },
  sub: { fontSize: 13, color: '#888', margin: 0 },
  card: { background: '#fff', border: '1px solid #eee', padding: 24 },
  cardHead: { fontSize: 11, fontWeight: 600, letterSpacing: 2.5, textTransform: 'uppercase', color: '#aaa', marginBottom: 20, paddingBottom: 14, borderBottom: '1px solid #f5f5f5' },
  field: { marginBottom: 16 },
  label: { display: 'block', fontSize: 11, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', color: '#555', marginBottom: 6 },
  input: { width: '100%', padding: '10px 14px', border: '1.5px solid #e5e5e5', fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: "'Barlow',sans-serif", borderRadius: 0 },
  btnPrimary: { background: '#111', color: '#fff', border: 'none', padding: '10px 20px', fontSize: 12, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', cursor: 'pointer', fontFamily: "'Barlow',sans-serif" },
  btnRemove: { background: 'none', border: 'none', color: '#dc1414', fontSize: 12, cursor: 'pointer', padding: '4px 0', marginTop: 6 },
  uploadArea: { border: '2px dashed #e5e5e5', padding: 20, cursor: 'pointer', borderRadius: 4, transition: 'border-color 0.2s', marginTop: 8 },
  specsBox: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6, background: '#fafafa', border: '1px solid #f0f0f0', padding: '10px 14px', borderRadius: 4, marginBottom: 8 },
  specItem: { fontSize: 11, color: '#666' },
  infoBox: { background: '#fafafa', border: '1px solid #f0f0f0', padding: 12, fontSize: 11, color: '#888', lineHeight: 1.6, marginTop: 16 },
};
